import clone from 'clone';
import domToImage from 'dom-to-image';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEToolbox from './oe-toolbox';
import {OEColor} from '../../components/color-picker/oe-color';

/*
option = {
    uiLayer: boolean,
    transparency: boolean,
    size: {w: number, h: number},
    bgColor: string,
    attribution: {
        text: string,
        textID: string,
        imageURL: string,
        color: string or {x: number, y: number, z: number, w: number},
        font: {
            weight: number,
            size: number,
            name: string
        },
        alignment: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
        padding: number or {x: number, y: number}
    },
    imageFormat: ['jpeg', 'png'],
    quality: number,
    filename: string
};
*/

export const OECornerAlignment = {
    topLeft: 'top-left',
    topRight: 'top-right',
    bottomLeft: 'bottom-left',
    bottomRight: 'bottom-right'
};

const OEScreenshotTool = new class {

    constructor() {
        this.defaultOptions = {
            uiLayer: true,
            transparency: false,
            size: undefined,
            bgColor: undefined,
            attribution: undefined,
            imageFormat: undefined,
            quality: undefined,
            filename: undefined
        };
    }

    safe(dataUrl, filename)   {
        let link = document.createElement('a');
        link.download = filename;
        link.href = dataUrl;
        link.click();
    }

    newCanvas(size, bgColor) {
        let canvas = document.createElement('canvas');
        canvas.width = size.w; canvas.height = size.h;

        if(bgColor) {
            let ctx = canvas.getContext('2d');
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }

        return canvas;
    }

    copyCanvas(canvas)  {
        if(!canvas) return undefined;
        let newCanvas = document.createElement('canvas');
        newCanvas.width = canvas.width; newCanvas.height = canvas.height;
        let ctx = newCanvas.getContext('2d');
        ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);
        return newCanvas;
    }

    filterFn(oe, options)   {
        if(options.uiLayer) {
            return node => { return node._screenshotToolFilter_ui !== 1; };
        } else {
            return node => { return node._screenshotToolFilter_no_ui === 1; };
        }
    }

    modifierFn(oe, options)   {
        return node => {
            if(node.tagName !== 'BODY') return;
            node.style.background = 'rgba(56, 56, 56, 0)';
        };
    }

    updateFilterTags(oe, options)   {
        if(options.uiLayer) {
            let hiddenElements = document.getElementsByClassName('screenshot-filter-hide');
            for(let i = 0; i < hiddenElements.length; i++)  hiddenElements[i]._screenshotToolFilter_ui = 1;

            oe.element._screenshotToolFilter_ui = 1;

        } else {
            let showElements = document.getElementsByClassName('screenshot-filter-show');
            for(let i = 0; i < showElements.length; i++)  OEToolbox.iterateRelatedNodes(showElements[i], (element) => { element._screenshotToolFilter_no_ui = 1})

            let hiddenElements = document.getElementsByClassName('screenshot-filter-hide');
            for(let i = 0; i < hiddenElements.length; i++)  hiddenElements[i]._screenshotToolFilter_no_ui = 0;

            oe.element._screenshotToolFilter_no_ui = 0;
        }
    }

    takeCoreImage(oe, options)   {
        return new Promise(function (resolve, reject) {
            if(!oe || !oe.isReady())    { resolve(null); return; }

            let flags = 0;
            if(options.transparency)    flags |= oe.Module.ScreenshotFlag.transparency.value;
            if(!options.uiLayer)    flags |= oe.Module.ScreenshotFlag.noVPGizmo.value | oe.Module.ScreenshotFlag.noNoteGUI.value;

            oe.sharedInterface.screenshotFn(resolve, null, flags);
        })
        .then(uri => {
            return uri ? domToImage.impl.util.makeImage(uri) : null;
        })
        .then(domToImage.impl.util.delay(100));
    }

    takeUIImage(oe, options)    {
        this.updateFilterTags(oe, options);
        let domNode = document.body;
        let filter = this.filterFn(oe, options);
        let modifier = this.modifierFn(oe, options);

        /*
        domToImage.toSvg(domNode, {filter: filter, modifier: modifier})
        .then((data) => {
            this.safe(data, "Test.svg");
        });
        */
       
        return domToImage.toSvg(domNode, {filter: filter, modifier: modifier})
        .then(domToImage.impl.util.makeImage)
        .then(domToImage.impl.util.delay(100));
    }

    devicePixelRatio()    {
        return window.devicePixelRatio || 1;
    }

    positionFromAlignment(frameSize, objSize, padding, alignment) {
        let pos;
        switch(alignment){
            case OECornerAlignment.topLeft:
                pos = {x: padding.x, y: padding.y};
                break;
            case OECornerAlignment.topRight:
                pos = {x: frameSize.width - objSize.width - padding.x, y: padding.y};
                break;
            case OECornerAlignment.bottomRight:
                pos = {x: frameSize.width - objSize.width - padding.x, y: frameSize.height - objSize.height - padding.y};
                break;
            default:
                pos = {x: padding.x, y: frameSize.height - objSize.height - padding.y};
        }
        return pos;
    }

    addAttribution(oe, canvas, attribution)  {
        let promise = new Promise(function (resolve, reject) {
            resolve(canvas);
        });

        if(!canvas || typeof(attribution) !== 'object' || !attribution)    return promise;

        let padding = typeof(attribution.padding) === 'number' ? {x: attribution.padding, y: attribution.padding} : (typeof(attribution.padding) === 'object' ? attribution.padding : undefined);
        padding = Object.assign({x: 38, y: 25}, padding);

        let alignment = typeof(attribution.alignment) === 'string' ? attribution.alignment : 'bottom-left';

        if(typeof(attribution.imageURL) === 'string' && attribution.imageURL !== '')   {

            return promise
            .then(canvas => {
                return domToImage.impl.util.makeImage(attribution.imageURL)
                .then(attributionImage => {
                    let ctx = canvas.getContext('2d');
                    let pos = this.positionFromAlignment(canvas, attributionImage, padding, alignment);
                    ctx.drawImage(uiImage, pos.x, pos.y, attributionImage.width, attributionImage.height);
                    return canvas;
                })
            });
        }

        let text;

        if(typeof(attribution.textID) === 'string' && attribution.textID !== '' && oe && oe.isReady())    {
            text = oe.sharedInterface.getLocalizedStringEnc(attribution.textID);
        } else if(typeof(attribution.text) === 'string' && attribution.text !== '') {
            text = attribution.text;
        }

        if(text === undefined)  return promise;

        let color = 'rgb(132, 132, 132)';
        if(typeof(attribution.color) == 'string') {
            color = attribution.color;
        } else if(typeof(attribution.color) == 'object')  {
            color = OEColor.toStr(attribution.color, false, true);
        } else if(oe && oe.isReady()) {

            let borderBrightness = oe.sharedInterface.getUIControllerColorTheme().getBackgroundBorderBrightness();
            if(borderBrightness < 0.4)   {
                color = OEColor.toStr({x: borderBrightness + 0.28, y: borderBrightness + 0.28, z: borderBrightness + 0.28}, false, true);
            } else {
                color = OEColor.toStr({x: borderBrightness - 0.28, y: borderBrightness - 0.28, z: borderBrightness - 0.28}, false, true);
            }
        }

        let font = Object.assign({
            weight: 400,
            size: 20,
            name: 'Roboto,sans-serif'
        }, attribution.font);

        font = font.weight.toString() + ' ' + font.size.toString() + 'px ' + font.name;

        return promise
        .then(canvas => {
            let ctx = canvas.getContext('2d');
            ctx.font = font;
            ctx.fillStyle = color;

            let pos;
            switch(alignment){
                case OECornerAlignment.topLeft:
                    ctx.textBaseline = 'top';
                    ctx.textAlign = 'left'; 
                    pos = {x: padding.x, y: padding.y};
                    break;
                case OECornerAlignment.topRight:
                    ctx.textBaseline = 'top';
                    ctx.textAlign = 'right';
                    pos = {x: canvas.width - padding.x, y: padding.y};
                    break;
                case OECornerAlignment.bottomRight:
                    ctx.textBaseline = 'bottom';
                    ctx.textAlign = 'right';
                    pos = {x: canvas.width - padding.x, y: canvas.height - padding.y};
                    break;
                default:
                    ctx.textBaseline = 'bottom';
                    ctx.textAlign = 'left'; 
                    pos = {x: padding.x, y: canvas.height - padding.y};
            }

            ctx.fillText(attribution.text, pos.x, pos.y, Math.max(0, canvas.width - 2 * padding.x));
            return canvas;
        });
    }

    takeCanvas(moduleId, options)   {
        options = clone(options || this.defaultOptions);
        let oe = oeInterfaceManager.getInterface(moduleId);
        let domNode = document.body;
        let domRect = domNode.getBoundingClientRect();
        let pixelRatio = this.devicePixelRatio();
        options.size = options.size || {w: pixelRatio * domRect.width, h: pixelRatio * domRect.height};
        let canvas = this.newCanvas(options.size, options.bgColor);

        let coreFrame;
        if(oe && oe.element)    {
            let rect = oe.element.getBoundingClientRect();
            coreFrame = {x: pixelRatio * rect.top, y: pixelRatio * rect.left, w: pixelRatio * rect.width, h: pixelRatio * rect.height};
        }

        let promise = this.takeCoreImage(oe, options)
        .then(coreImage => {
            let ctx = canvas.getContext('2d');
            if(coreImage && coreFrame)   ctx.drawImage(coreImage, coreFrame.x, coreFrame.y, canvas.width - coreFrame.x, canvas.height - coreFrame.y);
            return canvas;
        })
        .then(canvas => {
            return this.takeUIImage(oe, options)
            .then(uiImage => {
                let ctx = canvas.getContext('2d');
                ctx.drawImage(uiImage, 0, 0, canvas.width, canvas.height);
                return canvas;
            })
        })
        .then(canvas => {
            return this.addAttribution(oe, canvas, options.attribution);
        });

        return promise;
    }

    canvasToDataURL(canvas, options)    {
        if(!canvas) return undefined;
        let jpg = options && options.imageFormat === 'jpeg';
        let data = canvas.toDataURL(jpg ? 'image/jpeg' : 'image/png', jpg ? options.quality || 1.0 : undefined);
        if(options.filename)    this.safe(data, options.filename);
        return data;
    }

    takeDataURL(moduleId, options)   {
        options = options || this.defaultOptions;
        return this.takeCanvas(moduleId, options)
        .then(canvas => {
            return this.canvasToDataURL(canvas, options);
        });
    }
};

export default OEScreenshotTool;